import styled, { css } from 'styled-components';

export const ChevronWrapper = styled.span<{ isOpen: boolean }>`
  display: flex;
  align-items: center;

  ${({ isOpen }) =>
    isOpen &&
    css`
      transition: transform 0.3s ease;
      transform: rotate(180deg);
    `}
`;
